import styled from "@emotion/styled";
import { ListItem as ChakraListItem } from "@chakra-ui/react";

export const ListItem = styled(ChakraListItem)`
  & p {
    display: inline;
  }
`;
